<script>
import Tag from 'element-ui/lib/tag';

export default Tag;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/tag.css';

.el-tag {
  &__close {
    @include rtl() {
      right: auto !important;
      left: -5px !important;
    }
  }
}
</style>
